import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { AssessmentRowComponent } from '../assessment-row/assessment-row.component';
import { EmrInputComponent } from "../../../../shared/emr-input/emr-input.component";
import { Patient } from 'src/app/calvin-emr-shared/models/patient.model';
import { EmrCheckboxComponent } from 'src/app/shared/emr-checkbox/emr-checkbox.component';
import { PainFormGroup } from 'src/app/calvin-emr-shared/models/assessments/pain.model';
import { FormOption } from 'src/app/shared/models/form-option.model';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { WnlGroupDirective } from '../wnl/wnl-group.directive';
import { WnlControlDirective } from '../wnl/wnl-control.directive';

@Component({
  selector: 'app-pain-assessment-form',
  templateUrl: './pain-assessment-form.component.html',
  styleUrls: ['./pain-assessment-form.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CommonModule,
    AssessmentRowComponent,
    EmrInputComponent,
    EmrCheckboxComponent,
    MatCheckboxModule,
    WnlGroupDirective,
    WnlControlDirective,
  ],
})
export class PainAssessmentFormComponent {

  painQualityOptions = [
    new FormOption('Sharp'),
    new FormOption('Dull'),
    new FormOption('Stabbing'),
    new FormOption('Burning'),
    new FormOption('Crushing'),
    new FormOption('Throbbing'),
    new FormOption('Shooting'),
    new FormOption('Aching'),
    new FormOption('Other'),
  ];

  formGroup = input.required<PainFormGroup>();
  patient = input.required<Patient>();

}
